import { OutOrderStateEnum } from "src/models/OutOrder";

export function translateOutOrderStatus(status: OutOrderStateEnum) {
  switch (status) {
    case OutOrderStateEnum.READY_TO_INVOICE:
      return 'Pronto para emitir NFe';
    case OutOrderStateEnum.PREPARING_FOR_DISPATCH:
      return 'Preparando para expedição';
    case OutOrderStateEnum.AWAITING_VALIDATION:
      return 'Aguardando validação';
    case OutOrderStateEnum.VALIDATING:
      return 'Validando';
    case OutOrderStateEnum.BLOCKED_TO_DISPATCH:
      return 'Bloqueado para expedição';
    default:
      return status || '---';
  }
}